<template>
  <div
    class="titled-section container"
    :class="{ 'has-icon': !!$slots.icon, 'left-gutter': !!$slots.icon && !alignContentLeft }"
  >
    <div class="titled-section__heading">
      <div class="header columns">
        <div class="column" :class="!!$slots.actions ? 'is-9' : 'is-12'">
          <div class="section__header">
            <div
              v-if="$slots.icon"
              class="section__icon"
              :class="!iconColour ? 'section__icon__default' : ''"
              :style="{ color: iconColour }"
            >
              <slot name="icon"></slot>
            </div>
            <div class="titles">
              <div class="section__title">
                <slot name="title" />
              </div>
              <div class="section__subtitle">
                <slot name="subtitle" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!!$slots.actions" class="column is-3 section__actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
    <div class="titled-section__content">
      <slot name="default" />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  alignContentLeft: {
    type: Boolean,
    default: false,
  },
  iconColour: {
    type: String,
  },
});
</script>

<style scoped lang="scss">
.titled-section {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);

  &__content {
    padding: 12px;
    max-height: 1000px;

    > :first-child {
      flex: 1;
    }
  }
  &.has-icon {
    padding: 0;

    .header {
      padding: 1.75rem 0.25rem;

      .column {
        padding: 0;
      }
    }

    &.left-gutter {
      .titled-section__content {
        padding: 0 4.25rem 2rem 4.25rem;
      }
    }
  }

  &:not(:last-child) {
    margin-bottom: 1.5em;
  }

  .section__header {
    display: flex;
    align-items: center;
  }

  .section__icon {
    flex: 0 0 auto;
    font-size: 1.5rem;
    width: 4rem;
    text-align: center;

    &__default {
      font-weight: 700;
      color: $color-netcall-salmon;
      fill: $color-netcall-salmon;
    }
  }

  .section__title {
    font-weight: 500;
    font-size: 1.2em;
  }

  .section__subtitle {
    opacity: 0.7;
    line-height: 1.35;
  }

  .section__actions {
    text-align: end;
  }

  &__heading {
    padding: 12px 12px 8px;
    background-color: #fff;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex: 1 1 auto;
    }
  }
}
</style>
